function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F8B64C;}\n\t.st1{fill:#40596B;}\n\t.st2{fill:#FFD164;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32,3.5c-0.4,0-0.8,0.2-1.1,0.4S30.5,4.6,30.5,5v4.8c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4 s0.8-0.2,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1V5c0-0.4-0.2-0.8-0.4-1.1S32.4,3.5,32,3.5L32,3.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M46.6,17.3c0.4,0,0.8-0.2,1.1-0.4l3.4-3.4c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6 c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3-0.3-0.7-0.4-1.1-0.4c-0.4,0-0.8,0.2-1.1,0.4l-3.4,3.4c-0.1,0.1-0.3,0.3-0.3,0.5 c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.3,0.5C45.8,17.1,46.2,17.3,46.6,17.3L46.6,17.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M57.4,28.9h-4.8c-0.4,0-0.8,0.2-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1s0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4h4.8 c0.4,0,0.8-0.2,1.1-0.4s0.4-0.7,0.4-1.1s-0.2-0.8-0.4-1.1S57.8,28.9,57.4,28.9L57.4,28.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M47.6,43.9c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.3 c-0.1,0.1-0.3,0.3-0.3,0.5C45,44.5,45,44.7,45,44.9c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.4,0.4,0.5l3.4,3.4c0.3,0.3,0.7,0.4,1.1,0.4 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.1-0.6,0.1-0.9c-0.1-0.3-0.2-0.6-0.4-0.8L47.6,43.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.4,43.9L13,47.3c-0.2,0.2-0.4,0.5-0.4,0.8c-0.1,0.3,0,0.6,0.1,0.9c0.1,0.3,0.3,0.5,0.6,0.7 c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.8-0.2,1.1-0.4l3.4-3.4c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1S16.5,43.7,16.4,43.9L16.4,43.9z "
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.4,28.9H6.6c-0.4,0-0.8,0.2-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1s0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4h4.8 c0.4,0,0.8-0.2,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1s-0.2-0.8-0.4-1.1C12.2,29,11.8,28.9,11.4,28.9L11.4,28.9z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.1,11.4c-0.3-0.3-0.7-0.4-1.1-0.4s-0.8,0.2-1.1,0.4c-0.1,0.1-0.3,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.3,0.5l3.4,3.4c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.2,1.1-0.4c0.1-0.1,0.3-0.3,0.3-0.5 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.5L15.1,11.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.2,50.2h-6.5c-0.4,0-0.8,0.2-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1v4c0,1.3,0.5,2.5,1.4,3.4 c0.9,0.9,2.1,1.4,3.4,1.4s2.5-0.5,3.4-1.4c0.9-0.9,1.4-2.1,1.4-3.4v-4c0-0.4-0.2-0.8-0.4-1.1S35.6,50.2,35.2,50.2L35.2,50.2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M48.5,29c-0.2-2.7-1.1-5.3-2.6-7.6c-1.5-2.3-3.5-4.2-5.8-5.5c-2.4-1.3-5-2-7.7-2.1c-2.7-0.1-5.4,0.6-7.8,1.8 c-2.4,1.2-4.5,3-6,5.3c-1.6,2.2-2.5,4.8-2.9,7.5c-0.3,2.7,0,5.4,1,7.9c1,2.5,2.6,4.8,4.6,6.5c1.2,1,2.1,2.2,2.8,3.6 c0.7,1.4,1,2.9,1,4.5v0.7c0,0.4,0.2,0.8,0.4,1.1s0.7,0.4,1.1,0.4h11c0.4,0,0.8-0.2,1.1-0.4s0.4-0.7,0.4-1.1V51 c0-1.6,0.4-3.1,1.1-4.5c0.7-1.4,1.6-2.7,2.8-3.7c2-1.7,3.5-3.8,4.4-6.2S48.7,31.6,48.5,29L48.5,29z"
});

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.cd5803d4b1aeed3b7a069ce4f0d580eb.svg";
export { ForwardRef as ReactComponent };